import React from 'react';
import { Box, BoxProps, styled } from '@mui/material';

export const Wrapper = styled(({ children, ...props }: BoxProps) => (
  <Box {...props}>{children}</Box>
))(() => ({
  color: 'var(--dk-text, black)',
  fontStyle: 'normal',
  fontWeight: '400',
  wordWrap: 'break-word',
  // 인라인 이미지가 코멘트 폭을 넘지 않도록 cap (오버플로 방지 — 확대는 하지 않음)
  '& img': {
    maxWidth: '100%',
    height: 'auto',
  },
}));
